var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.classNameBase.rootElement,
    ("" + (_vm.classNameBase.rootElement) + (_vm.classNameDirection[_vm.isYouSent]))
  ]},[_c('div',{class:[
      _vm.classNameBase.col,
      ("" + (_vm.classNameBase.col) + (_vm.classNameDirection[_vm.isYouSent]))
    ]},[(!_vm.isYouSent)?_c('div',{staticClass:"p-the-j05-chat-screen-panel-message__icon"},[_c('IconUserImage',{attrs:{"size":32}},[_c('img',{attrs:{"src":_vm.icon,"alt":""}})])],1):_vm._e(),_c('div',{class:[
        _vm.classNameBase.message,
        ("" + (_vm.classNameBase.message) + (_vm.classNameDirection[_vm.isYouSent]))
      ]},[_vm._t("content")],2),(_vm.nextItemTime !== _vm.time)?_c('div',{staticClass:"p-the-j05-chat-screen-panel-message__time"},[_c('SmallText',{attrs:{"color":"#333333","size":_vm.timeTextFontSize}},[_vm._v(_vm._s(_vm.time))])],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }